import { memo } from 'react'
import { cn } from '@/lib/utils'

const NameChangeTooltip = memo(
    ({ type, action, userTime, adAccountTime, originIcon: OriginIcon, actionIcon: ActionIcon }) => {
        // Determine entity type
        const entityType = type === 'campaign_name_changed' ? 'Campaign' : 'Ad'

        const originLabel =
            action.origin === 'meta'
                ? 'Meta Platform'
                : action.origin === 'system'
                  ? 'Turba App'
                  : action.actor_name || 'Manual Action'

        // Extract old and new names from extra_data
        let oldName = 'Unknown'
        let newName = 'Unknown'

        try {
            if (action.extra_data) {
                const parsed = JSON.parse(action.extra_data)
                oldName = parsed.old_value || oldName
                newName = parsed.new_value || newName
            }
        } catch (error) {
            console.warn('Error parsing name change data:', error)
        }

        return (
            <div className={cn('tw:flex tw:flex-col tw:gap-6 tw:box-border', 'tw:bg-[#071727]', 'tw:max-w-[589px]')}>
                <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
                    <div className="tw:flex tw:items-center tw:gap-3">
                        <div className="tw:relative tw:cursor-help tw:inline-block">
                            <ActionIcon size={27} />
                            {/* Origin indicator positioned at bottom-right corner */}
                            <div className="tw:absolute tw:bottom-0 tw:right-0 tw:translate-x-1/4 tw:translate-y-1/4">
                                <OriginIcon size={10} />
                            </div>
                        </div>
                        <div className="tw:flex tw:flex-col tw:gap-1">
                            <div className="tw:flex tw:items-center tw:gap-2">
                                <span className="tw:text-sm tw:font-medium tw:text-white">
                                    {entityType} <span className="tw:text-[#899CBD]">name updated</span> by{' '}
                                    {originLabel}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tw:grid tw:grid-cols-[1fr_auto_1fr] tw:gap-x-4 tw:gap-y-6">
                    <div className="tw:text-xl tw:text-white tw:break-words tw:self-start">{oldName}</div>
                    <div className="tw:flex tw:items-start tw:justify-center tw:self-start">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="tw:flex-shrink-0 tw:mt-1"
                        >
                            <path
                                d="M14 8L18 12M18 12L14 16M18 12H6"
                                stroke="#899CBD"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <div className="tw:text-xl tw:text-white tw:break-words tw:self-start">{newName}</div>

                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">User Time</span>
                        <span className="tw:text-sm">{userTime}</span>
                    </div>
                    <div></div>
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">Ad Account Time</span>
                        <span className="tw:text-sm">{adAccountTime}</span>
                    </div>
                </div>
            </div>
        )
    },
)

NameChangeTooltip.displayName = 'NameChangeTooltip'

export default NameChangeTooltip
